import { render } from "./AllServices.vue?vue&type=template&id=d2b7b1de&scoped=true"
import script from "./AllServices.vue?vue&type=script&lang=js"
export * from "./AllServices.vue?vue&type=script&lang=js"

import "./AllServices.vue?vue&type=style&index=0&id=d2b7b1de&scoped=true&lang=css"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2b7b1de"]])

export default __exports__